import DataTable from "../dataTables/DataTable";
import Popup from "reactjs-popup";
import { buildColDefs } from "../dataTables/buildColDefs";
import { TabbedContent } from "../tabs/TabbedContent";
import { CreationFormInput } from "./CreationForm";
import { useRef } from "react";
import { parseUtils } from "../../data-parsing/parseUtils";
import { IngredientTab } from "../../pages/recipes";

export function MultivaluedInputPopUp({
  trigger,
  data,
  setData,
  metadata,
  name,
  additionalFields,
}) {
  const colDefs = buildColDefs(metadata?.composedElements);
  const formRef = useRef();

  function handleChange(key) {
    const parsedData = parseUtils(formRef);
    data[key] = parsedData[0][key];
    setData({ ...data });
  }

  function updateValue(ingredient, ingredientList) {
    data[metadata?.name].push(...ingredientList);
    setData({ ...data });
  }

  function editElement(dataElement, index) {
    data[metadata?.name][index] = dataElement;
    setData({ ...data });
  }

  function deleteElement(id, index) {
    data[metadata?.name].splice(index, 1);
    setData({ ...data });
  }

  return (
    <Popup trigger={trigger} modal>
      {(close) => (
        <div
          className={""}
          style={{ width: "90%", height: "70rem", overflowX: "auto" }}
        >
          <div className={"card-box card-tabs shadow"}>
            <h4 className="header-title m-t-0 m-b-30 pull-right">{name}</h4>
            <TabbedContent
              defaultActive={1}
              tabHeaders={[
                <button data-toggle="tab" aria-expanded="false">
                  <i className="fas fa-plus-circle"></i> NUEVO
                </button>,
                <button data-toggle="tab" aria-expanded="true">
                  <i className="far fa-eye"></i> LISTAR
                </button>,
              ]}
            >
              <div className="fade in ">
                <IngredientTab
                  afterSubmit={updateValue}
                  ingredientListName={name}
                />
              </div>
              <div className="fade in ">
                <form
                  ref={formRef}
                  style={{ zIndex: 20, position: "relative" }}
                >
                  {additionalFields &&
                    Object.keys(additionalFields).map((key) => {
                      return (
                        <CreationFormInput
                          key={key}
                          name={key}
                          size={1}
                          inline={true}
                          defaultValue={data[key]}
                          inputData={additionalFields[key]}
                          onBlur={() => {
                            handleChange(key);
                          }}
                        />
                      );
                    })}
                </form>
                <DataTable
                  colDefs={colDefs}
                  data={data[metadata?.name]}
                  dataId={name}
                  resizable={true}
                  allowHiddenColumns={true}
                  scrollX={false}
                  deleteElement={deleteElement}
                  editElement={editElement}
                  className="table table-bordered panel-group m-t-30"
                />
              </div>
            </TabbedContent>
          </div>
        </div>
      )}
    </Popup>
  );
}

export function MultivaluedInputPopUpArray({
  trigger,
  data,
  setData,
  metadata,
  name,
  additionalFields,
}) {
  const colDefs = buildColDefs(metadata?.composedElements);
  const formRef = useRef();

  function handleChange(key) {
    const parsedData = parseUtils(formRef);
    data[key] = parsedData[0][key];
    setData({ ...data });
  }

  function updateValue(value, valueList) {
    data[metadata?.name].push(...valueList);
    setData({ ...data });
  }

  function editElement(dataElement, index) {
    const updatedData = [...data];
    console.log("updatedData", updatedData);
    console.log("dataElement", dataElement);
    updatedData[index] = dataElement;
    console.log("updatedData updated", updatedData);
    setData(updatedData);
  }

  function deleteElement(id, index) {
    data[metadata?.name].splice(index, 1);
    setData({ ...data });
  }

  return (
    <Popup trigger={trigger} modal>
      {(close) => (
        <div
          className={""}
          style={{ width: "100%", height: "70rem", overflowX: "auto" }}
        >
          <div className={"card-box card-tabs shadow"}>
            <h4 className="header-title m-t-0 m-b-30 pull-right">{name}</h4>

            <div className="fade in ">
              <DataTable
                colDefs={colDefs}
                data={data}
                dataId={name}
                resizable={true}
                allowHiddenColumns={true}
                scrollX={true}
                deleteElement={deleteElement}
                editElement={editElement}
                className="table table-bordered panel-group m-t-30"
              />
            </div>
          </div>
        </div>
      )}
    </Popup>
  );
}
